module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 047.688882c0.jpg";